export default __webpack_public_path__ + "static/media/instructor_spot_lesson.0fa97a24.svg";